import React from 'react'
import CurrentlyWorkingFor from './CurrentlyWorkingForCard';
import { fontStyle } from '../../Styles';

function Home() {
	return (
		<div style={{ ...fontStyle }}>
			<h1>Bailey Bruketta</h1>
			<p style={{  borderRadius: '15%'}}>Software Engineer</p>

			<CurrentlyWorkingFor />
		</div>
	);
}

export class HomeTitle extends React.Component{
	render(){
		return(
			<p style={{position: 'fixed', left: 0}}>Home</p>
		);
	}
}

export default Home
